<template>
    <div class="row azul p-2 p-md-4" data-aos="fade-up" data-aos-duration="1000">
        <div class="col-12">
            <hr>
            <h3 v-html="titulo"></h3>
            <div class="texto" v-html="texto"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CuadroTexto',
  props: {
    titulo: String,
    texto: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: 700;
  font-size: 22px;
}
.texto {
    padding: 20px 20px;
    font-size: 13px;
    font-weight: 400;
}
hr {
    width: 30px;
    text-align:left;
    margin-top: 0;
    margin-bottom: 15px;
    margin-left: 0;
    border: 2px solid #1900FF;
}
.azul {
    -moz-box-shadow: 8px 8px 0 #1900FF;
    -webkit-box-shadow: 8px 8px 0 #1900FF;
    box-shadow: 8px 8px 0 #1900FF;
    min-height: 260px;
    background: #FFF;
    margin: 20px;
    padding: 40px 0 0 30px !important;
}
@media only screen and (max-width: 990px){
    h3 {
        font-size: 19px;
        margin-top: 15px;
        margin-left: 10px;
    }
    .texto {
        padding: 20px 30px;
    }
    .azul {
        padding: 40px 0 25px 30px !important;
    }
}
</style>
